
import { IconButton } from '@material-ui/core';
import _ from 'lodash';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { GREEN, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import ArrowLeftIconCustom from '../../CustomIcons/ArrowLeftIconCustom.jsx';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import WitcoActivationSetupForm from '../../forms/Integrations/WitcoActivationSetupForm.jsx';
import WitcoActivationForm from '../../forms/Integrations/WitcoActivationForm.jsx';
import { localizeHelpCenterLink } from '../../../_config/utils.js';


@connect(state => ({ language: state.settings.language }))
class WitcoSettingsOperationalSection extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      witcoData: {
        token: null,
        buildings: null,
      },
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.WITCO_INTEGRATION));
    this.setState({ isActive });
  }

  async onWitcoGetBuildings(loginData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const buildings = await dispatch(UserActions.getWitcoBuildings(loginData.token));
      if (buildings) {
        const witcoData = {
          token: loginData.token,
          buildings,
        };
        this.setState({ witcoData });
      }
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      let errorMessage = 'integrationConnectionError';
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
    }
  }

  async onActivateWitcoIntegration(formData) {
    const { dispatch } = this.props;
    const { witcoData: { token, buildings } } = this.state;
    try {
      const buildingsSelectedIds = _.map(_.filter(buildings, building => (formData.buildings || []).includes(building.id)), building => building.id);
      const coldStartResources = formData.coldStartResources;
      const syncAllUsers = formData.syncAllUsers;
      const syncReservations = formData.syncReservations;
      const syncReservationsNoNewUsers = syncReservations && !syncAllUsers ? formData.syncReservationsNoNewUsers : false;
      const allowAccessMinutesBefore = syncReservations ? (parseInt(formData.allowAccessMinutesBefore || 0) || 0) : 0;
      const allowAccessMinutesAfter = syncReservations ? (parseInt(formData.allowAccessMinutesAfter || 0) || 0) : 0;
      const reservationsSyncMode = []
      if (formData.pin)
        reservationsSyncMode.push("PIN")
      if (formData.credentialRule)
        reservationsSyncMode.push("CREDENTIAL_RULE")
      if (formData.invitation)
        reservationsSyncMode.push("INVITATION")

      if (!syncReservations && !syncAllUsers && !coldStartResources)
        return;
      if (buildingsSelectedIds.length === 0)
        return;
      if (syncReservations && reservationsSyncMode.length === 0)
        return;
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const activationDTO = {        
        token,

        reservationDaysBefore: 0,
        reservationDaysAfter: 1,

        coldStartResources,
        syncAllUsers,
        syncReservations,
        syncReservationsOnlyIfUserExists: syncReservationsNoNewUsers,

        buildingIds: buildingsSelectedIds || [],
        reservationsSyncMode: syncReservations ? reservationsSyncMode : [],

        allowAccessMinutesBefore,
        allowAccessMinutesAfter,
      };
      await dispatch(UserActions.activateWitcoIntegrationForBusiness(activationDTO));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: true });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionSuccess" /></h6>),
        },
      }));
    } catch (error) {
      console.log(error);
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationConnectionError" /></h6>),
        },
      }));
    }
  }

  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const witcoIntegrationDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.WITCO_INTEGRATION));
      if (witcoIntegrationDTO && witcoIntegrationDTO.id) {
        await dispatch(UserActions.disableIntegration(witcoIntegrationDTO.id));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(UserActions.fetchCurrentActiveIntegrations());
        this.setState({ isActive: false });
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
          },
        }));
      } else {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
          },
        }));
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  onOpenActivationInfo() {
    const helpURL = localizeHelpCenterLink('witco-activation-steps');
    window.open(helpURL);
  }

  onGoBackToLogin() {
    const witcoData = {
      token: null,
      buildings: null,
    };
    this.setState({ witcoData })
  }

  render() {
    const { isActive, witcoData: { buildings } } = this.state;
    const { dispatch } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="witco" src="/imgs/common/integrationLogos/witco-logo.png" style={{ height: 50, alignSelf: 'center' }} />
        {isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            <MDButton
              title={<Entity key={isActive} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 0, marginTop: 10, width: '80%' }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
          <div style={{ width: '70%', margin: 'auto' }}>
            <h4 style={{ color: '#3f3f3f', textAlign: 'center', marginTop: 10, marginBottom: 30 }}><Entity entity="connectYoutAccount" /></h4>
            {!buildings ? (
              <div>
                <div style={{ marginTop: 20 }}>
                  <WitcoActivationForm
                    onSubmit={loginData => this.onWitcoGetBuildings(loginData)}
                  />
                </div>
                <MDButton
                  title={<Entity entity="activate" key={buildings} />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor="black"
                  containerStyle={{ margin: 0, marginTop: 10, marginBottom: 10 }}
                  onClick={() => dispatch(submit('WitcoActivationForm'))}
                />
              </div>
            ) : (
              <div>
                <div style={{ marginTop: 20 }}>
                  <WitcoActivationSetupForm
                    buildings={buildings}
                    onSubmit={witcoData => this.onActivateWitcoIntegration(witcoData)}
                  />
                </div>
                <MDButton
                  title={<Entity key={buildings} entity="connectYourAccount" />}
                  titleStyle={{ marginTop: 0, fontSize: 13 }}
                  backgroundColor="black"
                  containerStyle={{ margin: 0, marginTop: 10 }}
                  onClick={() => dispatch(submit('WitcoActivationSetupForm'))}
                />
                <IconButton onClick={() => this.onGoBackToLogin()}>
                  <ArrowLeftIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 5 }} />
                </IconButton>
                <Entity style={{ color: '#3f3f3f', marginTop: 2 }} entity="backToLogin" />
              </div>
          )}
          </div>
        )}
        <h5
          className="link-label"
          style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
          onClick={() => this.onOpenActivationInfo()}
        >
          <Entity entity="findOutMore" />
        </h5>
      </div>
    );
  }
}

export default WitcoSettingsOperationalSection;
